export const signInPath = '/sign-in';
export const signUpPath = '/sign-up';
export const newUserPath = '/new-user';
export const homePath = '/home/projects';
export const createOrgPath = '/onboarding/create-org';

/** The path the app is served under, without its trailing slash ('' at the root). BYOC images set it at container
 *  start (k8s/40-template-env-vars.sh), so it's only known at runtime there. */
export const basePath = import.meta.env.BASE_URL.replace(/\/$/, '');
export const withBasePath = (path: string) => basePath + path;
